import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { vendorFields } from './common/vendorFields';
import { msg } from '@lingui/core/macro';
import { cryptoRelationshipField } from './common/cryptoFields';

export const cryptoHoldingsMetadata = {
  displayName: msg({
    message: 'Crypto holdings',
    context: 'Activity data schema name for crypto holdings',
  }),
  fields: {
    ...coreFields,
    ...vendorFields,
    crypto_holding_quantity: {
      displayName: msg({
        message: 'Crypto holding quantity',
        context: 'The quantity of cryptocurrency held.',
      }),
    },
    crypto_holding_unit: {
      displayName: msg({
        message: 'Crypto holding unit',
        context: 'The abbreviation of the cryptocurrency.',
      }),
    },
    crypto_relationship: cryptoRelationshipField,
  },
} as const satisfies BatMetadataConfigEntry;
